import { useWatch } from 'react-hook-form';

import { useSankeyFormContext } from 'contexts/sankeyFormContext';
import { Box } from 'ui/Layout';

import { renderConfig } from '../../constants';

// This component is used by measureText() method to calculate label sizes
// before positioning the nodes in the Sankey diagram.
const SVGScratch: React.FC = () => {
  const { form } = useSankeyFormContext();
  const [fontFamily] = useWatch({
    control: form.control,
    name: ['font_family'],
  });

  return (
    <Box position="absolute" visibility="hidden" zIndex="hide">
      <svg
        id="svg_scratch"
        xmlns="http://www.w3.org/2000/svg"
        fontFamily={fontFamily}
        fontWeight={renderConfig.font.weight.normal}
      />
    </Box>
  );
};

export default SVGScratch;
